var defaultSize={width:0,height:0};export var getElementSize=function(a){if(!a)return defaultSize;var b=a.getBoundingClientRect(),c=b.width,d=b.height;return{width:c,height:d}};
//# sourceMappingURL=getElementSize.js.map